import { Step } from 'react-joyride';

export const dashboardTourSteps: Step[] = [
  {
    target: '.agent-cards-container',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">These are your agents!</h3>
        <p className="text-sm">
          They will help make sure that you never miss a thing and can get back to what really
          matters: informing your members!
        </p>
      </div>
    ),
    disableBeacon: true,
    placement: 'bottom',
    spotlightPadding: 10,
    styles: {
      spotlight: {
        borderRadius: 12,
      },
    },
    floaterProps: {
      disableAnimation: false,
      offset: 20,
    },
  },
  {
    target: '[data-tour="daily-update-button"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">Click this!</h3>
        <p className="text-sm">View your personalized daily update.</p>
      </div>
    ),
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="daily-update-content"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">This is where you will find your daily update</h3>
        <p className="text-sm">
          This will be all of your bills, where they are in the process, any newly filed bills that
          include your keywords.
        </p>
      </div>
    ),
    placement: 'right',
  },
  {
    target: '[data-tour="upcoming-events-button"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">Upcoming Events</h3>
        <p className="text-sm">
          Stay on top of committee hearings, deadlines, and important legislative events.
        </p>
      </div>
    ),
    placement: 'bottom',
  },
  {
    target: '[data-tour="notifications-button"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">Notifications</h3>
        <p className="text-sm">
          Get real-time alerts about bill updates, committee actions, and other important changes.
        </p>
      </div>
    ),
    placement: 'bottom',
  },
  {
    target: '[data-tour="sidebar-nav"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">This is your nav</h3>
        <p className="text-sm">
          You will find everything you are looking for in one of these tabs.
        </p>
      </div>
    ),
    placement: 'right',
  },
  {
    target: '[data-tour="user-profile"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">This is where you will set up your account!</h3>
        <p className="text-sm">Click it.</p>
      </div>
    ),
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="user-settings-link"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">Click on My Profile to set up your account</h3>
        <p className="text-sm">
          It is very important that you set your company summaries. We will generate keywords for
          you if you wish.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="report-bug-feature"]',
    content: (
      <div>
        <h3 className="text-lg font-bold mb-2">Finally our favorite!</h3>
        <p className="text-sm">
          Let us know what's wrong and let us know what we can do right! Happy Tracking!
        </p>
      </div>
    ),
    placement: 'right',
  },
];
